<!-- <p>visitor-analytics-container works!</p> -->
<div class="visitor-analytics-container">
  <section>
    <mat-grid-list
      [cols]="screenSize == ScreenType.Mobile ? 1 : 2"
      rowHeight="120px"
      ><mat-grid-tile rowspan="3"
        ><div
          [ngClass]="{
            'visitor-analytics-counters':
              screenSize == ScreenType.Desktop ||
              screenSize == ScreenType.Tablet,
            'visitor-analytics-counters-mobile': screenSize == ScreenType.Mobile
          }"
        >
          <mat-grid-list cols="3" rowHeight="120px">
            <mat-grid-tile colspan="3"
              ><div
                [ngClass]="{
                  'visitor-analytics-counter-values':
                    screenSize == ScreenType.Desktop ||
                    screenSize == ScreenType.Tablet,
                  'visitor-analytics-counter-values-mobile':
                    screenSize == ScreenType.Mobile
                }"
              >
                <div>
                  <h3>{{ "Unique Visitor" | uppercase }}</h3>
                  <h5>Visitors in the current month</h5>
                </div>
                <div>
                  <strong
                    ><h2>{{ uniqueVisitors }}</h2></strong
                  >
                </div>
              </div></mat-grid-tile
            >
            <mat-grid-tile colspan="3"
              ><div
                [ngClass]="{
                  'visitor-analytics-counter-values':
                    screenSize == ScreenType.Desktop ||
                    screenSize == ScreenType.Tablet,
                  'visitor-analytics-counter-values-mobile':
                    screenSize == ScreenType.Mobile
                }"
              >
                <div>
                  <h3>{{ "Hot Hour" | uppercase }}</h3>
                  <h5>Most check-in timeslot</h5>
                </div>
                <div>
                  <strong
                    ><h2>{{ criticalRiskHour }}</h2>
                  </strong>
                </div>
              </div></mat-grid-tile
            >
            <mat-grid-tile colspan="3"
              ><div
                [ngClass]="{
                  'visitor-analytics-counter-values':
                    screenSize == ScreenType.Desktop ||
                    screenSize == ScreenType.Tablet,
                  'visitor-analytics-counter-values-mobile':
                    screenSize == ScreenType.Mobile
                }"
              >
                <div>
                  <h3>{{ "Total Unchecked Out " | uppercase }}</h3>
                  <h5>Count of visitors pending checkout</h5>
                </div>
                <div>
                  <strong
                    ><h2>{{ currentDayVisitors }}</h2></strong
                  >
                </div>
              </div></mat-grid-tile
            >
          </mat-grid-list>
        </div></mat-grid-tile
      ><mat-grid-tile rowspan="3">
        <div class="tile-div">
          <mat-card class="visitor-charts-card"
            ><mat-card-header
              [ngClass]="{
                'visitor-counter-card-header':
                  screenSize == ScreenType.Desktop ||
                  screenSize == ScreenType.Tablet,
                'visitor-counter-card-header-mobile':
                  screenSize == ScreenType.Mobile
              }"
              >Monthly Visitors</mat-card-header
            >
            <mat-card-content class="visitor-charts-card-content">
              <app-visitor-bar-graph
                [chartHeight]="300"
                [chartData]="monthlyVisitorBarGraph"
              ></app-visitor-bar-graph>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
  </section>
  <br />
  <mat-divider></mat-divider>
  <br />
  <section>
    <mat-grid-list cols="1" rowHeight="120px">
      <mat-grid-tile rowspan="3">
        <div class="tile-div">
          <mat-card class="visitor-charts-card"
            ><mat-card-header
              [ngClass]="{
                'visitor-counter-card-header':
                  screenSize == ScreenType.Desktop ||
                  screenSize == ScreenType.Tablet,
                'visitor-counter-card-header-mobile':
                  screenSize == ScreenType.Mobile
              }"
              >Inbound/Outbound Bandwidth</mat-card-header
            >
            <mat-card-content class="visitor-charts-card-content">
              <app-visitor-in-out-bound
                [chartHeight]="285"
                [visitorInOutGraphDetails]="monthlyVisitorInOutGraph"
              ></app-visitor-in-out-bound>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
  </section>
  <br />
  <mat-divider></mat-divider>
  <br />
  <section *ngIf="false">
    <mat-grid-list
      [cols]="screenSize == ScreenType.Mobile ? 1 : 2"
      rowHeight="120px"
      gutterSize="25px"
    >
      <mat-grid-tile rowspan="3">
        <div class="tile-div">
          <mat-card class="visitor-system-card"
            ><mat-card-header
              [ngClass]="{
                'visitor-counter-card-header':
                  screenSize == ScreenType.Desktop ||
                  screenSize == ScreenType.Tablet,
                'visitor-counter-card-header-mobile':
                  screenSize == ScreenType.Mobile
              }"
              >SYSTEM LOGS
            </mat-card-header>
            <mat-card-content class="visitor-tickets-card-content">
              <app-system-logs></app-system-logs>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-grid-tile>
      <mat-grid-tile rowspan="3" *ngIf="false">
        <div class="tile-div">
          <mat-card class="visitor-system-card"
            ><mat-card-header
              [ngClass]="{
                'visitor-tickets-card-header':
                  screenSize == ScreenType.Desktop ||
                  screenSize == ScreenType.Tablet,
                'visitor-tickets-card-header-mobile':
                  screenSize == ScreenType.Mobile
              }"
              ><div>NEW TICKETS</div>
              <div>
                <button (click)="onAddTicket()" mat-icon-button>
                  <mat-icon>add_circle</mat-icon>
                </button>
                <button mat-icon-button>
                  <mat-icon>clear</mat-icon>
                </button>
              </div>
            </mat-card-header>
            <mat-card-content class="visitor-tickets-card-content">
              <div class="card-content">
                <mat-card *ngFor="let item of visitorTickets">
                  <mat-card-header>
                    <div class="header-image">
                      <img
                        mat-card-avatar
                        [src]="profilePic"
                        alt="User Profile"
                      />
                    </div>
                    <div class="header-titile-substitle">
                      <h5>{{ item.ticketCreateBy }}</h5>

                      <span>{{
                        getFormatedDateTime(item.ticketCreateDate)
                      }}</span>
                    </div>
                  </mat-card-header>
                  <mat-card-content
                    ><div class="card-ticket-descriptions">
                      <div>
                        <b>Current Status:</b> &nbsp;
                        <i>
                          {{
                            item.ticketStatus == "0"
                              ? "OPEN"
                              : item.ticketStatus == "1"
                              ? "REVIEW"
                              : item.ticketStatus == "2"
                              ? "CLOSED"
                              : item.ticketStatus == "3"
                              ? "RESOLVED"
                              : ""
                          }}</i
                        >
                      </div>
                      {{ item.ticketDescription }}
                    </div></mat-card-content
                  >
                </mat-card>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
  </section>
</div>
